// utils/helpers.js - COMPLETE VERSION

// Format time from seconds to MM:SS
export const formatTime = (seconds) => {
  if (seconds < 0 || isNaN(seconds)) return "0:00";
  const m = Math.floor(Math.max(0, seconds) / 60);
  const s = Math.max(0, seconds) % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
};

// Get CEFR color for display
export const getCEFRColor = (level) => {
  const colors = {
    A1: '#9e9e9e', 
    A2: '#757575', 
    B1: '#4caf50',
    B2: '#2196f3', 
    C1: '#ff9800', 
    C2: '#f44336'
  };
  return colors[level] || '#757575';
};

// Get CEFR description
export const getCEFRDescription = (level) => {
  const descriptions = {
    'A1': 'Beginner - Can understand and use familiar everyday expressions.',
    'A2': 'Elementary - Can communicate in simple and routine tasks.',
    'B1': 'Intermediate - Can understand the main points of clear standard input.',
    'B2': 'Upper Intermediate - Can understand complex technical texts.',
    'C1': 'Advanced - Can understand a wide range of demanding texts.',
    'C2': 'Proficient - Can understand virtually everything heard or read.'
  };
  return descriptions[level] || 'Level not specified';
};

// Calculate correct answers dengan validasi
export const correctCount = (userAnswers, answerKeys) => {
  if (!userAnswers || !answerKeys || typeof userAnswers !== 'object') return 0;
  
  try {
    return Object.entries(userAnswers).filter(([index, answer]) => {
      const questionIndex = parseInt(index);
      return !isNaN(questionIndex) && 
             answerKeys[questionIndex] !== undefined && 
             answer !== undefined &&
             answer !== null &&
             answer === answerKeys[questionIndex];
    }).length;
  } catch (error) {
    console.error('Error in correctCount:', error);
    return 0;
  }
};

// TOEFL Score Conversion Table - STRUCTURE TABLE FIXED
export const TOEFL_CONVERSION_TABLE = {
  listening: {
    50:68,49:67,48:66,47:65,46:64,45:63,44:62,43:61,42:60,41:59,40:58,39:57,38:56,37:55,
    36:54,35:53,34:52,33:51,32:50,31:49,30:48,29:47,28:46,27:45,26:44,25:43,24:42,23:41,
    22:40,21:39,20:38,19:37,18:36,17:35,16:34,15:33,14:32,13:31,12:30,11:29,10:28,9:27,
    8:26,7:25,6:24,5:23,4:22,3:21,2:20,1:19,0:18
  },
  structure: {
    // ✅ PERBAIKAN: Structure 27 harus 56, bukan 55
    40:68,39:67,38:66,37:65,36:64,35:63,34:62,33:61,32:60,31:59,30:58,29:57,28:56,27:56, // ← FIXED: 27:56
    26:54,25:53,24:52,23:51,22:50,21:49,20:48,19:47,18:46,17:45,16:44,15:43,14:42,13:41,
    12:40,11:39,10:38,9:37,8:36,7:35,6:34,5:33,4:32,3:31,2:30,1:29,0:28
  },
  reading: {
    50:67,49:66,48:65,47:64,46:63,45:62,44:61,43:60,42:59,41:58,40:57,39:56,38:55,37:54,
    36:53,35:52,34:51,33:50,32:49,31:48,30:47,29:46,28:45,27:44,26:43,25:42,24:41,23:40,
    22:39,21:38,20:37,19:36,18:35,17:34,16:33,15:32,14:31,13:30,12:29,11:28,10:27,9:26,
    8:25,7:24,6:23,5:22,4:21,3:20,2:19,1:18,0:17
  }
};

export const calculateTOEFLScore = (listeningCorrect, structureCorrect, readingCorrect) => {
  try {
    console.log('🔍 [DEBUG] calculateTOEFLScore INPUT:', {
      listeningCorrect, 
      structureCorrect, 
      readingCorrect,
      types: {
        listening: typeof listeningCorrect,
        structure: typeof structureCorrect, 
        reading: typeof readingCorrect
      }
    });

    const lc = Math.max(0, Math.min(50, parseInt(listeningCorrect) || 0));
    const sc = Math.max(0, Math.min(40, parseInt(structureCorrect) || 0));
    const rc = Math.max(0, Math.min(50, parseInt(readingCorrect) || 0));
    
    console.log('🔍 [DEBUG] Normalized counts:', { lc, sc, rc });

    // Debug each conversion
    const listeningScore = TOEFL_CONVERSION_TABLE.listening[lc] || 18;
    const structureScore = TOEFL_CONVERSION_TABLE.structure[sc] || 28;
    const readingScore = TOEFL_CONVERSION_TABLE.reading[rc] || 17;
    
    console.log('🔍 [DEBUG] Section scores from table:', {
      listening: `Table[${lc}] = ${listeningScore}`,
      structure: `Table[${sc}] = ${structureScore}`,
      reading: `Table[${rc}] = ${readingScore}`
    });

    // Check exact table values
    console.log('🔍 [DEBUG] Table values check:', {
      listeningTable: TOEFL_CONVERSION_TABLE.listening,
      structureTable: TOEFL_CONVERSION_TABLE.structure, 
      readingTable: TOEFL_CONVERSION_TABLE.reading
    });

    const rawTotal = listeningScore + structureScore + readingScore;
    console.log('🔍 [DEBUG] Raw total:', rawTotal);

    const calculated = (rawTotal * 10) / 3;
    console.log('🔍 [DEBUG] Before rounding:', calculated);

    const totalScore = Math.round(calculated);
    console.log('🔍 [DEBUG] After rounding:', totalScore);

    const finalTotal = Math.min(Math.max(totalScore, 310), 677);
    console.log('🔍 [DEBUG] Final total:', finalTotal);

    return {
      listening: listeningScore,
      structure: structureScore,
      reading: readingScore,
      total: finalTotal
    };

  } catch (error) {
    console.error('❌ Error calculating TOEFL score:', error);
    return {
      listening: 31,
      structure: 31,
      reading: 31,
      total: 310
    };
  }
};

// Get CEFR level from TOEFL score dengan validasi
export const getCEFRLevel = (score) => {
  const normalizedScore = parseInt(score) || 0;
  
  if (normalizedScore >= 627) return 'C2';
  if (normalizedScore >= 587) return 'C1';
  if (normalizedScore >= 543) return 'B2';
  if (normalizedScore >= 497) return 'B1';
  if (normalizedScore >= 457) return 'A2';
  return 'A1';
};

// Clear all exam data including completion flags
export const clearExamData = () => {
  try {
    const itemsToRemove = [
      'listening_answers',
      'structure_answers', 
      'reading_answers',
      'listening_time',
      'structure_time',
      'reading_time',
      'listening_completed',
      'structure_completed',
      'reading_completed',
      'exam_start_time',
      'current_section'
    ];
    
    itemsToRemove.forEach(item => {
      localStorage.removeItem(item);
    });
    
    console.log('✓ All exam data cleared');
  } catch (error) {
    console.error('Error clearing exam data:', error);
  }
};

// Exit fullscreen safely
export const exitFullscreen = () => {
  try {
    if (document.exitFullscreen) {
      document.exitFullscreen().catch(() => {});
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen().catch(() => {});
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen().catch(() => {});
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen().catch(() => {});
    }
  } catch (err) {
    console.error('Error exiting fullscreen:', err);
  }
};

// Request fullscreen safely
export const requestFullscreen = async (element = document.documentElement) => {
  try {
    if (element.requestFullscreen) {
      await element.requestFullscreen();
    } else if (element.webkitRequestFullscreen) {
      await element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      await element.msRequestFullscreen();
    } else if (element.mozRequestFullScreen) {
      await element.mozRequestFullScreen();
    } else {
      return false; // Fullscreen not supported
    }
    return true;
  } catch (err) {
    console.error('Fullscreen request failed:', err);
    return false;
  }
};

// Check if exam section is completed dengan validasi
export const isSectionCompleted = (section) => {
  try {
    if (!section || typeof section !== 'string') return false;
    
    const completed = localStorage.getItem(`${section}_completed`);
    const answers = localStorage.getItem(`${section}_answers`);
    
    return completed === 'true' && answers !== null && answers !== undefined;
  } catch (error) {
    console.error('Error checking section completion:', error);
    return false;
  }
};

// Get exam progress dengan validasi
export const getExamProgress = () => {
  try {
    return {
      listening: isSectionCompleted('listening'),
      structure: isSectionCompleted('structure'),
      reading: isSectionCompleted('reading')
    };
  } catch (error) {
    console.error('Error getting exam progress:', error);
    return {
      listening: false,
      structure: false,
      reading: false
    };
  }
};

// Validasi apakah user answers valid
export const validateUserAnswers = (answers) => {
  if (!answers || typeof answers !== 'object') return false;
  
  try {
    const entries = Object.entries(answers);
    return entries.every(([key, value]) => {
      const index = parseInt(key);
      return !isNaN(index) && index >= 0 && 
             (value === null || value === undefined || 
              typeof value === 'string' || typeof value === 'number');
    });
  } catch (error) {
    return false;
  }
};

// Calculate progress percentage
export const calculateProgress = (current, total) => {
  if (!total || total <= 0) return 0;
  const progress = (current / total) * 100;
  return Math.min(Math.max(progress, 0), 100);
};

// Format score untuk display
export const formatScore = (score) => {
  const num = parseInt(score);
  return isNaN(num) ? '0' : num.toString();
};

// Debounce function untuk prevent multiple rapid calls
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// Throttle function untuk limit function calls
export const throttle = (func, limit) => {
  let inThrottle;
  return function(...args) {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
};

// Safe localStorage getter
export const getLocalStorage = (key, defaultValue = null) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    console.error(`Error getting ${key} from localStorage:`, error);
    return defaultValue;
  }
};

// Safe localStorage setter
export const setLocalStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    console.error(`Error setting ${key} in localStorage:`, error);
    return false;
  }
};

// Check if all sections are completed
export const isExamCompleted = () => {
  const progress = getExamProgress();
  return progress.listening && progress.structure && progress.reading;
};

// Get remaining sections
export const getRemainingSections = () => {
  const progress = getExamProgress();
  const remaining = [];
  
  if (!progress.listening) remaining.push('listening');
  if (!progress.structure) remaining.push('structure');
  if (!progress.reading) remaining.push('reading');
  
  return remaining;
};

// Calculate total time spent
export const calculateTotalTime = () => {
  try {
    const listeningTime = parseInt(localStorage.getItem('listening_time') || '0');
    const structureTime = parseInt(localStorage.getItem('structure_time') || '0');
    const readingTime = parseInt(localStorage.getItem('reading_time') || '0');
    
    return listeningTime + structureTime + readingTime;
  } catch (error) {
    console.error('Error calculating total time:', error);
    return 0;
  }
};

// Format date untuk display
export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  } catch (error) {
    return 'Invalid Date';
  }
};

// Validate email format
export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

// Validate password strength
export const validatePassword = (password) => {
  // Minimal 8 karakter, ada huruf besar dan kecil, angka
  const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
  return re.test(password);
};

// Generate random ID
export const generateId = () => {
  return Math.random().toString(36).substr(2, 9);
};

// Get current timestamp
export const getTimestamp = () => {
  return new Date().toISOString();
};

// Delay function
export const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// Truncate text
export const truncateText = (text, maxLength = 50) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substr(0, maxLength) + '...';
};

// Capitalize first letter
export const capitalizeFirst = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};
